import { useLayoutEffect } from 'react';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { isIbcStandsAgentUser } from '@/hooks/layoutConstructor/iberiaUserHelpers';
import { useUser } from '@/hooks/useUser';

export const ApplicationPageTitle = () => {
  const { userEntity } = useUser();
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { loading },
    actions: pageActions,
  } = usePageContext();
  const {
    state: { step },
  } = useApplicationContext();

  const isIberiaStandsFlow = !!userEntity && isIbcStandsAgentUser(userEntity);

  // The guards live inside the effect so the hook always runs in the same order,
  // whatever `loading` and `isIberiaStandsFlow` do between renders.
  useLayoutEffect(() => {
    if (loading || !isIberiaStandsFlow || !step) {
      return;
    }
    pageActions.setCustomTitle(getTextIdTranslation(`APPLICATION_IBERIA_CARDS_STEP_${step}`));
  }, [step, loading, isIberiaStandsFlow]);

  return null;
};
